import { P } from "orcs-design-system";

const InboxEmpty = () => <P m="0">Nothing needs your action.</P>;

export default InboxEmpty;
